import { render, staticRenderFns } from "./BlockTravelInformationFixedPriceTicket.vue?vue&type=template&id=01574aa8&"
import script from "./BlockTravelInformationFixedPriceTicket.vue?vue&type=script&lang=js&"
export * from "./BlockTravelInformationFixedPriceTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports